const STATUS_VARIANT_MAP = {
  draft: 'secondary',
  review: 'primary',
  approved: 'success',
  rejected: 'danger',
  additional: 'info',
  deleted: 'dark',
  released: 'success',
}

function normalizeStatusCode(status) {
  if (!status) return ''
  const raw = typeof status === 'object' ? (status.code || status.name || '') : status
  return String(raw).toLowerCase().trim().replace(/\s/g, '_')
}

export function getPlanningStatusCode(item) {
  const status = item && item.status
  if (!status) return ''
  return normalizeStatusCode(status)
}

export function getPlanningStatusVariant(statusOrItem) {
  const code = typeof statusOrItem === 'object' && statusOrItem !== null
    ? normalizeStatusCode(statusOrItem)
    : (statusOrItem ? String(statusOrItem).toLowerCase() : '')
  return STATUS_VARIANT_MAP[code] || 'secondary'
}

export function getPlanningStatusLabelKey(statusOrItem) {
  const code = typeof statusOrItem === 'object' && statusOrItem !== null
    ? normalizeStatusCode(statusOrItem)
    : (statusOrItem ? String(statusOrItem).toLowerCase() : '')
  if (!code) return ''
  const key = `planning.status_${code}`
  return key
}
